module.exports = __webpack_public_path__ + "img/shot_tx19112001.180c78b2.jpg";